// @ts-nocheck
import store from "../../../../store"
import {Network } from "../../.."
import api from "../../../../../api/axios"

export class Adjustments {
	static async getUser(userId) {
		let loginData = await api.post(`user/${userId}/login`)
		loginData = loginData?.data

		const token = loginData?.token
		console.log("Getting user profile in Adjustments.js");
		const user = await api.get("user/v2/profile", token )

		return { ...user?.data, token }
	}

	static async getPlans(token) {
		const response = await Network.AxiosWrapper({
			method: "GET",
			target: "user/plan",
			token
		})

		const userPlans = response?.data?.data.map((plan) => {
			return new Network.API.Profile.PlanModel(plan)
		})

		return userPlans
	}

	static async getAdjustment(adjustmentId) {
		const url = ``
		const response = await Network.AxiosWrapperV2.get({ url })

		return response?.data?.data
	}

	static async createAdjustment(userId, planId, payload) {
		const url = `transaction/v2/${userId}/${planId}/adjustment`
		await api.post(url,payload)

		const message = "Successfully created adjustment."
		store.setNotification("notification", true, { msg: message })
	}
}

export default Adjustments
